import {
  Box,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import AppBarCustom from "../component/AppBar";
import styled from "@emotion/styled";
import GaleriPage from "./komponen-page/Galeri";
import KomponenCard from "./komponen-page/KomponenCard";
import YoutubeCard from "./komponen-page/YoutubeCard";
import DokumenPage from "./komponen-page/Dokumen";
import FotoPage from "./komponen-page/Foto";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function Galeri_Dokumen(params) {
  const theme = useTheme();
  const file = params.file;
  const Komponen = (props) => {
    return (
      <KomponenCard
        id={props.id}
        title={props.title}
        data={params.data.filter((item) => item.nama == props.title)[0]}
        image={
          params.file.filter((item) => item.id_foreign == "-" + props.id)[0]
        }
      />
    );
  };
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: 0,
        bgcolor: "#E1E1E1",
      }}
    >
      <AppBarCustom selected="File" />
      {/* <Toolbar sx={{ padding: 10 }} /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader theme={theme} />
        {/* <Typography
          variant="h4"
          sx={{ fontWeight: "bold", marginBottom: 2 }}
          align="left"
        >
          Galeri
        </Typography> */}
        <Grid container direction={"column"} spacing={3}>
          <Grid>
            <FotoPage id={100} data={params.file} />
          </Grid>
        </Grid>
<br></br>
        {/* <Typography
          variant="h4"
          sx={{ fontWeight: "bold", marginBottom: 2 }}
          align="left"
        >
          Dokumen
        </Typography> */}
        <Grid container direction={"column"} spacing={3}>
          <Grid>
            <DokumenPage id={100} data={params.file} />
          </Grid>
        </Grid>
      </Box>

      
    </Box>
  );
}
